// extracted by mini-css-extract-plugin
export var actions = "_6q-8";
export var arrow = "_6q-5";
export var card = "_6q-0";
export var cardWrapper = "_6q-9";
export var fieldName = "_6q-3";
export var newValue = "_6q-6";
export var oldValue = "_6q-4";
export var orangeGlowFade = "_6q-c";
export var productSection = "_6q-1";
export var scrollToBottom = "_6q-b";
export var scrollToBottomAnchor = "_6q-a";
export var scrollToBottomIcon = "_6q-d";
export var showAllButton = "_6q-7";
export var table = "_6q-2";